import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { paySchema } from '../../../../shared/validators/schemas/pay.schema';
import { setStatusSchema } from '../../../../shared/validators/schemas/set-status.schema';
import { VehicleRoadWorthyCheckRecordDto } from '../../dtos/vehicle-road-worthy-check-record.dto';
import { VehicleRoadWorthyCheckActionEnum } from '../../enums/vehicle-road-worthy-check-action.enum';
import { VehicleRoadWorthyCheckStatusEnum } from '../../enums/vehicle-road-worthy-check-status.enum';

/**
 * Validates if an action can be performed by validating the record data.
 * @param record - The record for the data validation.
 * @param action - The action to be validated.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canPerformAction = (
	record: VehicleRoadWorthyCheckRecordDto,
	action: VehicleRoadWorthyCheckActionEnum,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	const fixedStatuses = [
		VehicleRoadWorthyCheckStatusEnum.PENDING,
		VehicleRoadWorthyCheckStatusEnum.EXPIRED,
		VehicleRoadWorthyCheckStatusEnum.ACTIVE,
	];

	switch (action) {
		case VehicleRoadWorthyCheckActionEnum.ACTIVATE:
			validationResult = setStatusSchema(
				VehicleRoadWorthyCheckStatusEnum.ACTIVE,
				fixedStatuses,
			).validate(record, {
				abortEarly,
			});
			break;

		case VehicleRoadWorthyCheckActionEnum.PENDING:
			validationResult = setStatusSchema(
				VehicleRoadWorthyCheckStatusEnum.PENDING,
				fixedStatuses,
			).validate(record, {
				abortEarly,
			});
			break;

		case VehicleRoadWorthyCheckActionEnum.EXPIRED:
			validationResult = setStatusSchema(
				VehicleRoadWorthyCheckStatusEnum.EXPIRED,
				fixedStatuses,
			).validate(record, {
				abortEarly,
			});
			break;

		case VehicleRoadWorthyCheckActionEnum.APPROVE:
			// TODO: Approval flow
			break;

		case VehicleRoadWorthyCheckActionEnum.REJECT:
			// TODO: Approval flow
			break;

		case VehicleRoadWorthyCheckActionEnum.PAY:
			validationResult = paySchema().validate(record, {
				abortEarly,
			});
			break;

		case VehicleRoadWorthyCheckActionEnum.CREATE_MAINTENANCE:
			break;

		default:
			throw new Error(`Unknown action: ${action}`);
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
